import { render, staticRenderFns } from "./templateAgeGroup.vue?vue&type=template&id=4a46c320&scoped=true"
import script from "./templateAgeGroup.vue?vue&type=script&lang=js"
export * from "./templateAgeGroup.vue?vue&type=script&lang=js"
import style0 from "./templateAgeGroup.vue?vue&type=style&index=0&id=4a46c320&prod&scoped=true&lang=css"
import style1 from "./templateAgeGroup.vue?vue&type=style&index=1&id=4a46c320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46c320",
  null
  
)

export default component.exports